// extracted by mini-css-extract-plugin
export default {"containerWrapper":"advertiseManageItem_containerWrapper__hHcuv","title":"advertiseManageItem_title__B5K4W","editButton":"advertiseManageItem_editButton__hvjqL"};